import React, { Component } from 'react'

import PresentOptionsForm from './PresentOptionsForm'

export default class PresentMenu extends Component {
  state = {
    options: null
  }
  startPresenting = options => {
    const { addToChannel, onAddToChannel, closeMenu } = this.props
    onAddToChannel(addToChannel, options)
    closeMenu()
  }
  render () {
    const { closeMenu, presentTypeSelected, addToChannel, album, selectedImages } = this.props

    const defaultType = album && album.presentation_type || 'kenburns'
    const albumStructure = album && JSON.parse(album.json_data)

    return (
      <div>
        <PresentOptionsForm
          onSubmit={this.startPresenting}
          onCancel={closeMenu}
          presentTypeSelected={presentTypeSelected}
          initialValues={{
            presentation_type: defaultType,
            presentation_speed: album && album.presentation_speed || (defaultType === 'floating' ? 30 : 3),
            presentation_transition: album && album.presentation_transition || (defaultType === 'floating' ? 5 : 1),
            presentation_sort: album && album.presentation_sort || null
          }}
          defaultSort={albumStructure ? albumStructure.sort.value + (albumStructure.sort.operator ? '-' + albumStructure.sort.operator : '') : null}
          confirmText={addToChannel ? 'Add to Channel' : 'Present'}
          imageSelection={selectedImages.length !== 0}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/present/PresentMenu.js